var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action-button",class:{ disabled: _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.busy)?_c('spinner'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }